import { render, staticRenderFns } from "./ReportDesktop.vue?vue&type=template&id=7dfae0bc&scoped=true&"
import script from "./ReportDesktop.vue?vue&type=script&lang=ts&"
export * from "./ReportDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfae0bc",
  null
  
)

export default component.exports